//  date = "yyyy-mm-dd"
export const getISOdate = (dateString) => {
  const [year, month, day] = dateString.split('-').map(Number)
  // Constructing date object with yyyy, mm-1 (0-indexed), dd and zero hours
  const date = new Date(Date.UTC(year, month - 1, day, 0, 0, 0))
  // Getting ISO string
  return date.toISOString()
}
